import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const GateContext = createContext();

export const GateProvider = ({ children }) => {
  const [access, setAccess] = useState(() => {
    const stored = localStorage.getItem('family_gate_access');
    return stored ? JSON.parse(stored) : {};
  });

  const checkAccess = (section) => {
    if (access['shared']) return true;
    if (access['admin']) return true;
    
    // Luka/Klara passwords unlock their own + Family + Trips
    if (section === 'family' || section === 'trips') {
      return access['luka'] === true || access['klara'] === true;
    }
    return access[section] === true;
  };

  const unlockSection = async (section, password) => {
    try {
      // Check shared master password
      const { data: isShared, error: sharedErr } = await supabase.rpc('verify_section_password', { 
        sec: 'shared', 
        pass: password 
      });
      
      if (isShared) {
        const newAccess = { ...access, shared: true };
        updateAccess(newAccess);
        return { success: true, type: 'shared' };
      }

      // Check specific section
      const { data, error } = await supabase.rpc('verify_section_password', { 
        sec: section, 
        pass: password 
      });
      
      if (error) throw error;
      
      if (data === true) {
        const newAccess = { ...access, [section]: true };
        updateAccess(newAccess);
        return { success: true };
      }
      return { success: false, message: 'Incorrect password' };
    } catch (err) {
      return { success: false, message: err.message };
    }
  };

  const updateAccess = (newAccess) => {
    setAccess(newAccess);
    localStorage.setItem('family_gate_access', JSON.stringify(newAccess));
  };

  const lockSection = (section) => {
    const newAccess = { ...access };
    if (section === 'all') {
      updateAccess({});
    } else {
      delete newAccess[section];
      updateAccess(newAccess);
    }
  };

  const getUnlockedSection = () => {
    if (access.shared) return 'Family Archive';
    if (access.luka) return 'Luka';
    if (access.klara) return 'Klara';
    return null;
  };

  return (
    <GateContext.Provider value={{ access, checkAccess, unlockSection, lockSection, getUnlockedSection }}>
      {children}
    </GateContext.Provider>
  );
};

export const useGate = () => useContext(GateContext);